module.exports = __webpack_public_path__ + "img/KinokoTable35.eb042963.jpg";